/**
 * The single definition of the web app's "you cannot read this pool" state.
 *
 * Both `apps/app/src/features/poolScreen/PoolScreenPane.tsx` and
 * `apps/app/src/features/poolSettings/PoolSettingsPane.tsx` import from
 * here so the two screens cannot disagree about what a `FORBIDDEN_POOL`
 * refusal looks like. This implements the Q1 part B decision from
 * ISSUE-512's open-questions record (dated 2026-08-22): an inline
 * no-access state, with the shared error modal reserved for genuine system
 * failures.
 */

export const POOL_NO_ACCESS_CODE = "FORBIDDEN_POOL";
export const POOL_NO_ACCESS_TITLE = "You don't have access to this pool.";
export const POOL_NO_ACCESS_BODY =
  "This link may be out of date, or you may have left the pool. Go back to your pools to pick another one.";
export const POOL_NO_ACCESS_ACTION_LABEL = "Back to your pools";

export function isPoolNoAccessCode(code: string | null | undefined): boolean {
  return code === POOL_NO_ACCESS_CODE;
}
